export const BASE_CLASS = 'collections-perseus';
